export const APMA2AButtonConfig = {
  backgroundColor: "#389c74",
  height: "40px",
  text: "Pay by Bank",
  textColor: "#fff",
  width: "100px",
};
